import Axios from '../../../utils/union-axios'

const preFix = '/web-h5'

/**
 * 获取充电营销H5页面(仅查询有资格参与的活动)
 * @param data 
 * @returns 
 */
export function GetHomePageConfig(data) {
  return Axios.get(`${preFix}/charge/marketingHomepage/getMarketingHomePage`, data)
}

/**
 * 获取充电营销H5页面(查询所有已配置的活动)
 * @param data 
 * @returns 
 */
export function GetHomePageConfigAll(data) {
  return Axios.get(`${preFix}/charge/marketingHomepage/getMarketingHomePageAll`, data)
}

/**
 * 通过活动编码查询适用站点列表
 * @param data 
 * @returns 
 */
export function GetStationList(data) {
  return Axios.post(`${preFix}/charge/marketingHomepage/getStationListByActivityCode`, data)
}

/**
 * 营销页面领奖
 * @param data 
 * @returns 
 */
export function GetAward(data) {
  return Axios.post(`${preFix}/charge/marketingHomepage/claim`, data)
}


export function getActivitySimpleInfo(data) {
  return Axios.post(`/web-h5/charge/marketingHomepage/getActivitySimpleInfo`, data)
}